import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/12-1_fileexcel.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const FileExcel: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default FileExcel;
